import { lazy as reactLazy, type ComponentType } from "react";

export function isChunkLoadError(error: any): boolean {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;

  const message = error.message || "";
  return (
    message.includes("Failed to fetch dynamically imported module") || // Chrome, Edge
    message.includes("error loading dynamically imported module") || // Firefox
    message.includes("Importing a module script failed") || // Safari
    message.includes("Loading chunk") // Webpack 호환
  );
}

function retryImport<T>(importFn: () => Promise<T>, retries: number, delay: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const attempt = (remaining: number) => {
      importFn()
        .then(resolve)
        .catch((error) => {
          if (isChunkLoadError(error) && remaining > 0) {
            setTimeout(() => attempt(remaining - 1), delay);
          } else {
            reject(error);
          }
        });
    };
    attempt(retries);
  });
}

export function lazyLoad<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
  options: { retries?: number; delay?: number } = {},
) {
  const { retries = 3, delay = 1500 } = options;
  return reactLazy(() => retryImport(importFn, retries, delay));
}
